export default __webpack_public_path__ + "static/media/vehicleTag.23eefdb4.svg";